import { useTranslation } from 'react-i18next'
import { DownloadIcon } from '@dhl-ui/icons'
import { IconButton, Tooltip } from '@dhl-ui/components'
import { downloadJson } from '~/common/util'

type Props = {
  filename: string
  payload: any
}

export const DownloadButton = ({ filename, payload }: Props) => {
  const { t } = useTranslation()
  return (
    <Tooltip title={t('admin.downloadFile', { filename })}>
      <IconButton aria-label="download file" onClick={() => downloadJson(filename, payload)}>
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  )
}
